import axios from 'axios';
import { authenticationService } from '../context/AuthService';

class ConnectAPI {
  constructor() {
    let user = authenticationService.currentUserValue;
    let baseURL = document.getElementsByTagName('base')[0].getAttribute('href');
    let service = axios.create({
      baseURL: baseURL,
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    if (user) {
      service.interceptors.request.use(
        (config) => {
          config.headers.Authorization = `Bearer ${user.token.key}`;
          return config;
        },
        (error) => Promise.reject(error)
      );
    }
    this.service = service;
  }

  handleSuccess = (response) => {
    return response;
  };

  handleError = (error) => {
    console.log(error);
    console.log(error.response);
    switch (error.response.status) {
      case 401:
        localStorage.clear('currentUser');
        this.redirectTo(document, '/login');
        break;
      // case 403:
      //   console.log('403');
      //   console.log(document.getElementsByTagName('base')[0]);
      //   console.log(document.getElementsByTagName('base'));
      //   localStorage.clear('currentUser');
      //   this.redirectTo(document, '/register');
      //   break;
      // case 404:
      //   this.redirectTo(document, '/404');
      //   break;
      /*default:
        this.redirectTo(document, '/500')
        break;*/
    }
    return Promise.reject(error);
  };

  redirectTo = (document, path) => {
    document.location = path;
  };

    get = (path, payload, callback, parameters) => {
        console.log('get', payload);
    var config = {
      headers: { 'Access-Control-Allow-Origin': '*' },
    };
    return this.service
      .get(path, payload, config)
      .then((response) => callback(response.status, response.data, parameters));
  };

  patch = (path, payload, callback) => {
    return this.service
      .request({
        method: 'PATCH',
        url: path,
        responseType: 'json',
        data: payload,
      })
      .then((response) => callback(response.status, response.data));
  };

  post = (path, payload, callback) => {
    var config = {
      headers: { 'Access-Control-Allow-Origin': '*' },
    };
    return this.service
      .request({
        method: 'POST',
        url: path,
        data: payload,
      })
      .then((response) => callback(response.status, response.data));
    };
    postmultifile = (path, payload, callback) => {
      return this.service
        .request({
          method: 'POST',
          url: path,
          data: payload,
          headers: {
            "Content-Type": "multipart/form-data"
          },
          maxContentLength: Infinity,
          maxBodyLength: Infinity
        })
        .then((response) => callback(response.status, response.data));
      };
    getWithParams = (path, payload, callback, parameters) => {
        var config = {
            headers: { 'Access-Control-Allow-Origin': '*' },
        };
        return this.service
            .get(path, { params: { payload: payload } }, config)
            .then((response) => callback(response.status, response.data, parameters));
    };

}

export default ConnectAPI;
